import axios from 'axios';
import {
  IGoodCollection,
  IGoodListPayload,
  IGood,
  IGoodParams,
  IUpdateGoodPayload,
  IRequestForGoodsApprovalPayload,
  IManuallyAddedGoodListPayload,
  ICreateGoodPayload,
} from 'entities/Goods/Goods.models';

const basePath = 'good';

export const goodsTransport = {
  get: (payload: IGoodListPayload): Promise<IGoodCollection> => axios.post(`${basePath}/list`, payload),
  getById: ({ id, ...params }: IGoodParams): Promise<IGood> => axios.get(`${basePath}/${id}`, { params }),
  create: (payload: ICreateGoodPayload): Promise<IGood> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateGoodPayload): Promise<IGood> => axios.patch(`${basePath}`, payload),
  getManuallyAddedGoodList: (payload: IManuallyAddedGoodListPayload): Promise<IGoodCollection> =>
    axios.post(`${basePath}/manually-added-list`, payload),
  sendRequestForGoodsApproval: (payload: IRequestForGoodsApprovalPayload): Promise<void> =>
    axios.post(`${basePath}/send-request-for-approval`, payload),
};
